<div class="row align-items-end">
    <div class="col-12">
        <div class="form-section">
            <div class="form-section-title font-mont-bold">
                MR Decision Rule: {{modelName}}
            </div>
            <div class="form-row">
                <div class="form-group col-8" [formGroup]="myform">
                    <label for="outcome" class="col-form-label">Outcome:</label>
                    <select id="outcome" class="form-control form-control-sm" name="outcome"
                        formControlName="outcomeSelect" (change)="onChangeOutcome()">
                        <option *ngFor="let outcome of outcomes" [ngValue]="outcome">
                            {{outcome.description}}
                        </option>
                    </select>
                </div>
                <div class="form-group col-4" [formGroup]="myform">
                    <div class="toggle-wrapper">
                        <div class="toggle checkcross">
                            <input id="statusSwitch" type="checkbox" formControlName="statusSwitch"
                                class="custom-switch-cls" (change)="onChangeModelStatus()" />
                            <label class="toggle-item" for="statusSwitch">
                                <div class="check"></div>
                            </label>
                        </div>
                        <div class="name">Status ({{myform.controls.statusSwitch.value ? 'Active' : 'Inactive'}})</div>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-12" [formGroup]="myform">
                    <label for="dataRobotModel" class="col-form-label">DataRobot
                        Model:</label>
                    <select id="dataRobotModel" class="form-control form-control-sm" name="dataRobotModel"
                        formControlName="dataRobotModelSelect" (change)="onChangeDataRobotModel()">
                        <option *ngFor="let dataRobotModel of dataRobotModels" [ngValue]="dataRobotModel">
                            {{dataRobotModel.description}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-12" [formGroup]="myform">
                    <label for="mrModelPriority" class="col-form-label">Priority:</label>
                    <input id="mrModelPriority" type="text" formControlName="mrModelPriority" class="form-control"
                        placeholder="999" name="mrModelPriority" mask="999" on-focusout="onChangePriority()">
                </div>
            </div>
        </div>
    </div>
</div>
<div class="clear"></div>
<div class="form-section">
    <div class="form-section-title font-mont-bold">
        Attributes
    </div>
    <table class="table">
        <thead>
            <tr>
                <th scope="col" class="font-mont-semi-bold">Attribute</th>
                <th scope="col" class="text-center font-mont-semi-bold">Operator
                </th>
                <th scope="col" class="text-center font-mont-semi-bold">Value
                </th>
                <th scope="col" class="text-center font-mont-semi-bold">Remove
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let attribute of model.attributes" class="row-data">
                <td scope="row">{{attribute.dataRobotAttributeName}}</td>
                <td class="text-center">{{attribute.operatorDescription}}</td>
                <td class="text-center">{{attribute.value}}</td>
                <td class="text-center cursor-poiner" (click)="onRemoveClick(attribute)" id="remove-attribute-link">
                    <i class="fa fa-minus"></i>
                </td>
            </tr>
        </tbody>
    </table>
    <form (ngSubmit)="onCreateNewAttributeSubmit()">
        <button class="btn btn-primary float-right" type="submit" data-toggle="modal"
            data-target="#createAttributeModal" [disabled]="modelDisabled" id="create-attribute-button">
            Create Attribute
        </button>
        <div class="clear"></div>
    </form>
</div>

<div class="modal fade" id="createAttributeModal" tabindex="-1" role="dialog" aria-labelledby="createAttributeModal"
    data-keyboard="false" data-backdrop="static" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <img src="/assets/images/icons/close_b.svg" />
                    CLOSE WINDOW
                </button>
            </div>
            <div class="modal-body">
                <h5 class="modal-title w-100 text-left font-mont-bold" id="exampleModalLongTitle">
                    <img src="/assets/images/icons/add_blue.svg" />
                    Create new attribute
                </h5>
                <form [formGroup]="newAttributeForm">
                    <div class="row">
                        <div class="col-12">
                            <div class="form-row">
                                <div class="form-group col-12">
                                    <label for="mAttribute"
                                        [ngClass]="{ 'color-red': addNewAttributeSubmitted && newAttributeForm.controls.description.errors }">Attribute:
                                        *</label>
                                    <select id="mAttribute" class="form-control" formControlName="description"
                                        [ngClass]="{ 'is-invalid': addNewAttributeSubmitted && newAttributeForm.controls.description.errors }">
                                        <option *ngFor="let attribute of attributes" [ngValue]="attribute">
                                            {{attribute.description}}
                                        </option>
                                    </select>
                                    <div *ngIf="addNewAttributeSubmitted && newAttributeForm.controls.description.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="newAttributeForm.controls.description.errors.required">
                                            Attribute is required.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-row">
                                <div class="form-group col-12">
                                    <label for="mOperator"
                                        [ngClass]="{ 'color-red': addNewAttributeSubmitted && newAttributeForm.controls.operator.errors }">Operator:
                                        *</label>
                                    <select id="mOperator" class="form-control" formControlName="operator"
                                        [ngClass]="{ 'is-invalid': addNewAttributeSubmitted && newAttributeForm.controls.operator.errors }">
                                        <option *ngFor="let operator of operators" [ngValue]="operator">
                                            {{operator.operator}}
                                        </option>
                                    </select>
                                    <div *ngIf="addNewAttributeSubmitted && newAttributeForm.controls.operator.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="newAttributeForm.controls.operator.errors.required">
                                            Operator is required.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-row">
                                <div class="form-group col-12">
                                    <label for="mValue"
                                        [ngClass]="{ 'color-red': addNewAttributeSubmitted && newAttributeForm.controls.value.errors }">Value:
                                        *</label>
                                    <input type="text" id="mValue" class="form-control" formControlName="value"
                                        [ngClass]="{ 'is-invalid': addNewAttributeSubmitted && newAttributeForm.controls.value.errors }"
                                        placeholder="Value">
                                    <div *ngIf="addNewAttributeSubmitted && newAttributeForm.controls.value.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="newAttributeForm.controls.value.errors.required">
                                            Value is required.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <button type="submit" id="createAttributeCancelButton"
                                class="btn btn-secondary btn-lg col-md-12 col-xs-12 round-button font-mont-regular float-right"
                                data-dismiss="modal">CANCEL</button>
                            <button type="submit" id="createAttributeCreateButton"
                                class="btn btn-primary btn-lg col-md-12 col-xs-12 round-button font-mont-regular float-right"
                                (click)="onCreateClick()">CREATE</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>